module.exports = __webpack_public_path__ + "img/DerAufprall11.c8c6a2f8.jpg";